"use strict";

var _classCallCheck = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _get = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _getPrototypeOf = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/RyoheiNagasawa/Portfolio/portfolio1/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatableColor = void 0;

var OptionsColor_1 = require("../OptionsColor");

var ColorAnimation_1 = require("./ColorAnimation");

var AnimatableColor = /*#__PURE__*/function (_OptionsColor_1$Optio) {
  _inherits(AnimatableColor, _OptionsColor_1$Optio);

  function AnimatableColor() {
    var _this;

    _classCallCheck(this, AnimatableColor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AnimatableColor).call(this));
    _this.animation = new ColorAnimation_1.ColorAnimation();
    return _this;
  }

  _createClass(AnimatableColor, [{
    key: "load",
    value: function load(data) {
      _get(_getPrototypeOf(AnimatableColor.prototype), "load", this).call(this, data);

      this.animation.load(data === null || data === void 0 ? void 0 : data.animation);
    }
  }], [{
    key: "create",
    value: function create(source, data) {
      var color = source !== null && source !== void 0 ? source : new AnimatableColor();

      if (data !== undefined) {
        color.load(typeof data === "string" ? {
          value: data
        } : data);
      }

      return color;
    }
  }]);

  return AnimatableColor;
}(OptionsColor_1.OptionsColor);

exports.AnimatableColor = AnimatableColor;